import { rem, rgba } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  padding-bottom: ${rem('20px')};
  display: flex;
  flex-direction: column;
  gap: ${rem('8px')};
`;

export const StyledLabel = styled.label`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
  pointer-events: none;
`;

export const StyledInput = styled.input`
  text-align: left;
  width: 100%;
  padding: 0;
  padding-bottom: ${({ theme }) => rem(theme.spacings.xs)};
  color: ${({ theme, disabled, value }) =>
    disabled && value === ''
      ? rgba(theme.colors.cross.grayson, 0.3)
      : theme.colors.cross.black};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid
    ${({ disabled, theme }) =>
      disabled ? 'transparent' : theme.colors.cross.silverFox};
  transition: all 0.3s ease;
  appearance: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.cross.grayson};
    opacity: ${({ disabled }) => (disabled ? 0.3 : 0.6)};
    transition: all 0.3s ease;
  }

  &:focus {
    border-bottom-color: ${({ theme }) => theme.colors.cross.deepBlu};
    outline: none;
  }
`;
